import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Button } from "antd";
import { GITHUB_AUTHORIZE } from "api/Github";
import Card from "../Card";
import GitHubLogo from "../../../common/assets/gitHubLogo.png";
import styles from "../styles.module.css";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import ConnectModal from "components/Modals/ConnectModal";

const { Text } = Typography;

const Auth = ({ loading, setAuthenticated }) => {
  const [connectModal, setConnectModal] = useState(false);
  const location = useLocation();
  const { id } = queryString.parse(location.search);

  const handleAuth = () => {
    window.location.href = GITHUB_AUTHORIZE(id);
  };
  return (
    <Card title="Github" style={{ height: "140px" }}>
      <Row>
        <Col md={2}>
          <img style={{ width: 50 }} src={GitHubLogo} alt="gitHub" />
        </Col>
        <Col md={15}>
          <div style={{ width: "80%", margin: "auto" }}>
            <Text>Connect Github to monitor and track pull requests</Text>
          </div>
        </Col>
        <Col md={7}>
          <Button
            onClick={() => setConnectModal({ label: "Github", workspace: id })}
            type="primary"
            size="large"
            color="#029875"
            className={styles.connectBtn + " px-7 w-full"}
            loading={loading}
          >
            Connect
          </Button>
        </Col>
      </Row>
      {connectModal && (
        <ConnectModal
          visible={connectModal}
          setVisible={setConnectModal}
          callback={handleAuth}
          setAuthenticated={setAuthenticated}
        />
      )}
    </Card>
  );
};

export default Auth;
